import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=154f0492&"
import script from "./Supplier.vue?vue&type=script&lang=js&"
export * from "./Supplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154f0492')) {
      api.createRecord('154f0492', component.options)
    } else {
      api.reload('154f0492', component.options)
    }
    module.hot.accept("./Supplier.vue?vue&type=template&id=154f0492&", function () {
      api.rerender('154f0492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/Supplier.vue"
export default component.exports